(() => {
  const root = document.querySelector('[data-plp-page-type]');
  if (!root || root.dataset.plpAnalyticsInitialized === 'true') return;

  root.dataset.plpAnalyticsInitialized = 'true';
  let eventSequence = 0;

  const hasConsent = () => ['accepted', 'true'].includes(localStorage.getItem('theme-cookie-bar-accepted'));

  const getDataLayer = () => {
    if (!hasConsent()) return null;
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  };

  const getFilters = () => {
    const filters = {};
    const params = new URLSearchParams(window.location.search);

    params.forEach((value, key) => {
      if (!key.startsWith('filter.') || value === '') return;
      filters[key] ||= [];
      filters[key].push(value);
    });

    return filters;
  };

  const getItems = () => Array.from(root.querySelectorAll('[data-product-card]')).map((card, index) => ({
    item_id: card.dataset.analyticsItemId || undefined,
    item_name: card.dataset.analyticsItemName || undefined,
    item_brand: card.dataset.analyticsItemBrand || undefined,
    item_variant: card.dataset.analyticsItemVariantId || undefined,
    price: Number(card.dataset.analyticsItemPrice || 0),
    index: index + 1,
    item_list_name: root.dataset.plpListName || undefined,
    item_url: card.dataset.analyticsItemUrl || undefined,
  })).filter((item) => item.item_id && item.item_name);

  const getNumberFromText = (selector) => {
    const text = root.querySelector(selector)?.textContent || '';
    const match = text.replace(/\./g, '').match(/\d+/);
    return match ? Number(match[0]) : null;
  };

  const getMetrics = (items) => ({
    page: Number(new URLSearchParams(window.location.search).get('page') || root.querySelector('[data-plp-current-page]')?.dataset.plpCurrentPage || 1),
    total_pages: Number(root.querySelector('[data-plp-total-pages]')?.dataset.plpTotalPages || 0) || undefined,
    items_count: items.length,
    total_results: getNumberFromText('[data-plp-count], [data-search-count]') || Number(root.dataset.plpTotalResults || 0) || undefined,
  });

  const push = (event, payload = {}) => {
    const dataLayer = getDataLayer();
    if (!dataLayer) return;

    eventSequence += 1;
    dataLayer.push({
      event,
      event_id: `plp-${Date.now()}-${eventSequence}`,
      page_type: root.dataset.plpPageType,
      page_url: window.location.href,
      list_name: root.dataset.plpListName,
      search_term: root.dataset.plpSearchTerm || undefined,
      filters: getFilters(),
      ...payload,
    });
  };

  const pushListView = (reason = 'initial') => {
    const items = getItems();
    const metrics = getMetrics(items);

    push('view_item_list', {
      interaction_type: reason,
      ...metrics,
      ecommerce: {
        item_list_name: root.dataset.plpListName,
        items,
      },
    });

    if (root.dataset.plpPageType === 'search' && reason === 'initial') {
      push('search_results_view', metrics);
    }
  };

  const handleUpdate = (event) => {
    const reason = event.detail?.action || 'filter';
    push(reason === 'pagination' ? 'plp_pagination' : 'plp_filter', {
      ...getMetrics(getItems()),
      interaction_type: reason,
    });
    pushListView(reason);
  };

  const init = () => {
    window.setTimeout(() => pushListView('initial'), 250);
  };

  document.addEventListener('collection:updated', handleUpdate);
  document.addEventListener('collection:pageview', handleUpdate);
  document.addEventListener('collection:count-updated', () => pushListView('count_update'));
  document.addEventListener('search:updated', handleUpdate);
  window.addEventListener('cookie-consent-updated', () => window.setTimeout(() => pushListView('initial'), 500));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
